import { styled } from '@slal/ui';
import { FieldSet } from '@slal/ui/react-hook-form/fields';
import { Notification, relatedFieldIndent } from '~/components';

export const StyledNotification = styled(Notification)`
    margin-left: ${relatedFieldIndent};
`;

export const StyledFieldSet = styled(FieldSet)`
    margin-bottom: ${({ theme: { space } }) => space[4]};
`;
